import React, { useEffect } from 'react';
import { useHistory, HashRouter, Switch, Route, Redirect } from 'react-router-dom';
import { } from 'antd';
import { constantConfig } from 'web-common';
import Header from './Header';
import Footer from './Footer';


const { WEBSITE_PATHS } = constantConfig;


/**
 * 全局容器组件
 */
const Container = (props: any) => {
    const { routes } = props;
    const history = useHistory();


    useEffect(() => {
        // 默认home为首页
        const { location } = history;
        if (location.pathname === '/') {
            history.replace(WEBSITE_PATHS.home);
        }
    }, []);


    return (
        <div className="container h">
            <Header />
            <HashRouter>
                <Switch>
                    {(routes || []).map((route: any, index: number) => (<Route key={index} {...route} />))}
                </Switch>
            </HashRouter>
            <Footer />
        </div>
    );
};


export { Container };